import request from '@/utils/request'


export function merchantAddress(query) {
  return request({
    url: '/biz/admin/statistics/merchant/address',
    method: 'get',
    params: query
  })
}

export function merchantAmount(query) {
  return request({
    url: '/biz/admin/statistics/merchant/amount',
    method: 'get',
    params: query
  })
}

export function merchantFocus(query) {
  return request({
    url: '/biz/admin/statistics/merchant/focus',
    method: 'get',
    params: query
  })
}
